<div class="balance-block border">
  <div class="balance">
    <img src="assets/images/header/cash.svg" alt="balance" />
    <span class="mat-caption" [style]="hideBalance ? 'filter: blur(3px)' : 'filter: none'">{{ balance }}</span>
  </div>

  <div class="coin">
    <img src="assets/images/header/btc.svg" alt="balance" />
    <span class="mat-caption">BTC</span>
  </div>

  <mat-icon (click)="hideBalance = !hideBalance">{{ hideBalance ? 'visibility_off' : 'visibility' }}</mat-icon>
</div>
